import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTutorial } from '@/contexts/TutorialContext';

/**
 * TutorialRouteWatcher
 * - Lives inside the Router
 * - Advances navigation steps (like 'click-profile') after route changes
 */
export function TutorialRouteWatcher() {
  const location = useLocation();
  const { isActive, currentStepData, nextStep } = useTutorial();

  // Advance step 9 (save-profile) once navigation completes to '/'
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    if (currentStepData.id === 'save-profile' && location.pathname === '/') {
      nextStep();
    }
  }, [isActive, currentStepData, location.pathname, nextStep]);

  // Advance to next step when user reaches Parking Lot tab from Specialty Bays
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    const params = new URLSearchParams(location.search);
    const onParkingLot = params.get('tab') === 'parking-lot';
    if (onParkingLot && (currentStepData.id === 'specialty-bays-view' || currentStepData.id === 'parking-lot-tab')) {
      nextStep();
    }
  }, [isActive, currentStepData, location.search, nextStep]);

  // Advance from analytics-intro-manager to analytics-overview when user clicks Analytics button (manager flow)
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    if (currentStepData.id === 'analytics-intro-manager' && location.pathname === '/analytics') {
      nextStep();
    }
  }, [isActive, currentStepData, location.pathname, nextStep]);

  // Advance from analytics-intro to analytics-overview when user clicks Analytics button (user flow)
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    if (currentStepData.id === 'analytics-intro' && location.pathname === '/analytics') {
      nextStep();
    }
  }, [isActive, currentStepData, location.pathname, nextStep]);

  // Advance from analytics-technicians to next step when user navigates back to dashboard
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    if (currentStepData.id === 'analytics-technicians' && location.pathname === '/') {
      nextStep();
    }
  }, [isActive, currentStepData, location.pathname, nextStep]);

  // Advance from technician-passport-intro to technician-passport-details when user clicks technician name
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    if (currentStepData.id === 'technician-passport-intro' && location.pathname.startsWith('/technicians/')) {
      nextStep();
    }
  }, [isActive, currentStepData, location.pathname, nextStep]);

  // Advance from user-guide-select to user-guide-review when user navigates to /user-guide
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    if (currentStepData.id === 'user-guide-select' && location.pathname === '/user-guide') {
      nextStep();
    }
  }, [isActive, currentStepData, location.pathname, nextStep]);

  // Advance from account-settings-intro when user navigates to /account-settings
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    if (currentStepData.id === 'account-settings-intro' && location.pathname === '/account-settings') {
      nextStep();
    }
  }, [isActive, currentStepData, location.pathname, nextStep]);

  // Advance from user-guide-intro-user when user navigates to /user-guide
  useEffect(() => {
    if (!isActive || !currentStepData) return;

    if (currentStepData.id === 'user-guide-intro-user' && location.pathname === '/user-guide') {
      nextStep();
    }
  }, [isActive, currentStepData, location.pathname, nextStep]);

  return null;
}
